<template>
  <nav class="donor-form-progress" aria-label="Donation form progress">
    <div
      v-for="(step, index) in steps"
      :key="step.key"
      class="donor-form-progress__step"
      :class="stepClass(index + 1)"
    >
      <span class="donor-form-progress__indicator" aria-hidden="true">
        <CheckIcon v-if="index + 1 < currentStep" class="h-4 w-4" />
        <span v-else>{{ index + 1 }}</span>
      </span>
      <span class="donor-form-progress__label">{{ step.label }}</span>
    </div>
  </nav>
</template>

<script>
import { CheckIcon } from '@heroicons/vue/20/solid'

export default {
  name: 'DonorFormProgress',
  components: { CheckIcon },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const steps = [
      { key: 'personal', label: 'Personal' },
      { key: 'contact', label: 'Contact' },
      { key: 'payment', label: 'Payment' },
    ]

    const stepClass = (stepNumber) => {
      if (stepNumber < props.currentStep) return 'donor-form-progress__step--complete'
      if (stepNumber === props.currentStep) return 'donor-form-progress__step--active'
      return ''
    }

    return { steps, stepClass }
  },
}
</script>
